import { ApiClient } from "@/api/client";
import { Content } from "@/interfaces/content";
import { Route } from "vue-router";
import { ToastProgrammatic as Toast } from "buefy";
import app from "@/main";
import store from "@/store";

export const setUser = (to: Route, from: Route, next: Function) => {
  console.debug(`[DATAGUARD] - [setUser] - Setting data for ${to.fullPath}`);

  if (!store.state.jwt) {
    console.debug(
      `[DATAGUARD] - [setUser] - Failed, user not logged in at ${to.fullPath}. Go to /`
    );
    next("/");
  } else {
    const client = new ApiClient();
    client
      .getAccountInfo()
      .then(user => {
        store.commit("setUser", user);
        console.debug(
          `[DATAGUARD] - [setUser] - Success, set new data at ${to.fullPath}`
        );
        next();
      })
      .catch(err => {
        console.debug(
          `[DATAGUARD] - [setUser] - Failed, error at ${to.fullPath}: ${err}. Redirect to /`
        );

        next("/");
      });
  }
};

export const setFeed = (to: Route, from: Route, next: Function) => {
  console.debug(`[DATAGUARD] - [setFeed] - Setting data for ${to.fullPath}`);
  app.$Progress.start();
  app.$Progress.set(30);

  new ApiClient()
    .getFeed()
    .then(value => {
      store.commit("basic", {
        key: "feed",
        value: value
      });

      console.debug(
        `[DATAGUARD] - [setFeed] - Success, set new data at ${to.fullPath}`
      );

      app.$Progress.set(70);
      next();
    })
    .catch(error => {
      console.debug(
        `[DATAGUARD] - [setFeed] - Error while getting data at ${to.fullPath}: ${error}`
      );

      store.commit("basic", {
        key: "cannotLoadPage",
        value: true
      });

      app.$Progress.fail();
      next();
    });
};

export const setPurchases = (to: Route, from: Route, next: Function) => {
  console.debug(
    `[DATAGUARD] - [setPurchases] - Setting data for ${to.fullPath}`
  );
  app.$Progress.start();
  app.$Progress.set(30);

  new ApiClient()
    .getPurchases()
    .then(value => {
      store.commit("basic", {
        key: "purchases",
        value: value
      });

      console.debug(
        `[DATAGUARD] - [setPurchases] - Success, set new data at ${to.fullPath}`
      );

      app.$Progress.set(70);
      next();
    })
    .catch(error => {
      console.debug(
        `[DATAGUARD] - [setPurchases] - Error while getting data at ${to.fullPath}: ${error}`
      );

      store.commit("basic", {
        key: "cannotLoadPage",
        value: true
      });

      app.$Progress.fail();
      next();
    });
};

export const setContent = (to: Route, from: Route, next: Function) => {
  console.debug(`[DATAGUARD] - [setContent] - Setting data for ${to.fullPath}`);
  app.$Progress.start();
  app.$Progress.set(30);

  const contentId = to.params.id;

  const client = new ApiClient();

  client
    .getContent(contentId)
    .then((content: Content) => {
      app.$Progress.set(70);
      store.commit("setContent", content);
      console.debug(
        `[DATAGUARD] - [setContent] - Success, set new data at ${to.fullPath}`
      );
      next();
    })
    .catch(error => {
      console.debug(
        `[DATAGUARD] - [setContent] - Error while getting data at ${to.fullPath}: ${error}`
      );
      app.$Progress.fail();
      Toast.open({
        type: "is-danger",
        message: "Video nicht gefunden",
        duration: 5000,
        queue: false
      });
      store.commit("basic", {
        key: "loadingContent",
        value: true
      });
      next(from.name || "/");
    });
};

export const setCategoryView = (to: Route, from: Route, next: Function) => {
  console.debug(
    `[DATAGUARD] - [setCategoryView] - Setting data for ${to.fullPath}`
  );
  app.$Progress.start();
  app.$Progress.set(30);

  const category = to.params.category;

  const client = new ApiClient();

  Promise.all([client.getVideosByCategory(category), client.getTags("video")])
    .then(([contents, categories]: [Content[], string[]]) => {
      store.commit("basic", {
        key: "videoCategories",
        value: categories
      });
      store.commit("setContentsByCategory", {
        category,
        contents
      });
      console.debug(
        `[DATAGUARD] - [setCategoryView] - Success, set new data at ${to.fullPath}`
      );
      next();
    })
    .catch(error => {
      console.debug(
        `[DATAGUARD] - [setCategoryView] - Error while getting data at ${to.fullPath}: ${error}`
      );
      app.$Progress.fail();
      Toast.open({
        type: "is-danger",
        message: "Kategorie nicht gefunden",
        duration: 5000,
        queue: false
      });
      store.commit("basic", {
        key: "loadingContent",
        value: true
      });
      next(from.name || "/");
    });
};
